import React, { useEffect, useState } from "react";

import {
  AnchorLink,
  Banner,
  Button,
  Chip,
  Layout,
  Text,
} from "@kidslivesafe/sc-react";
import { useAppSelector, useHandlePageNavigate } from "../../../hooks/hooks";
import { selectAccountSubscriptionStatus } from "../../../features/authentication/authenticationSlice";
import { parseDate } from "../../../utils";
import { selectPauseDetails } from "../../../features/subscriptions/subscriptionSlice";

const PauseBanner: React.FC = () => {
  const [displayBanner, setDisplayBanner] = useState<boolean>(false);
  const pauseDetails = useAppSelector(selectPauseDetails);
  const accountSubscriptionStatus = useAppSelector(
    selectAccountSubscriptionStatus,
  );

  const pageNavigate = useHandlePageNavigate();

  useEffect(() => {
    if (accountSubscriptionStatus === "PAUSED") {
      setDisplayBanner(true);
    } else {
      setDisplayBanner(false);
    }
  }, [accountSubscriptionStatus]);

  return (
    <>
      <Banner
        showBanner={displayBanner}
        setShowBanner={setDisplayBanner}
        position="bottom"
        displayX={false}
      >
        <Layout
          type="grid"
          gridProps={{
            templateColumns: "3fr-1fr",
            alignItems: "center",
          }}
          breakpointStyles={{
            tablet: {
              type: "grid",
              gridProps: {
                templateColumns: "2fr-1fr",
                alignItems: "center",
              },
            },
            mobile: {
              type: "flex",
              flexProps: { direction: "column", gap: "xs" },
            },
          }}
        >
          <Layout
            type="flex"
            flexProps={{
              direction: "column",
              gap: "xs",
              alignItems: "flex-start",
            }}
          >
            <Chip chipText="Pause Successful" color="success" />
            <Text size="sm" fontWeight="bold" textAlign="left">
              Your membership will be paused on{" "}
              {pauseDetails &&
                pauseDetails.pauseAccessDate &&
                parseDate(pauseDetails.pauseAccessDate, "MM/DD/YYYY")}
            </Text>
            <Text size="sm" textAlign="left">
              No further action is required. You can review your pause details
              in{" "}
              <AnchorLink
                role="button"
                inline
                size="sm"
                handleClick={() => {
                  if (window.location.pathname === "/my-account") {
                    const element = document.getElementById(
                      "membership-information",
                    );
                    if (!element) return;
                    window.scrollTo({
                      top: element.offsetTop,
                      behavior: "smooth",
                    });
                  } else {
                    pageNavigate("/my-account#membership-information");
                  }
                }}
              >
                My Account
              </AnchorLink>
              .
            </Text>
          </Layout>
          <Button
            buttonText="Close"
            color="primary"
            fill="fill"
            handleClick={() => {
              setDisplayBanner(false);
            }}
          />
        </Layout>
      </Banner>
    </>
  );
};

export default PauseBanner;
